import React, { useState } from "react";
import { StaticQuery } from "gatsby";
import { graphql } from "gatsby";
import "./Portfolio.scss";
import style from "./Portfolio.module.scss";

import CaseStudy from "./CaseStudy";
import GroupSelector from "./components/GroupSelector";

const seeAllGroup = { id: "0", name: "All" };

function extractUnique(items) {
  const uniqueIds = [...new Set(items.map(c => c.id))];
  return uniqueIds.map(id => items.find(t => t.id === id));
}

function isTagActive(tagId, activeTags) {
  return activeTags.length && activeTags.find(a => a.id === tagId);
}

function filterCaseStudies(allCaseStudies, activeTags, allTags, activeGroup) {
  const groupTags = allTags.filter(
    t => activeGroup.id === seeAllGroup.id || t.group.id === activeGroup.id
  );
  return activeTags.length === 0
    ? allCaseStudies.filter(c =>
        groupTags.find(t => c.tags.find(tag => t.id === tag.id))
      )
    : allCaseStudies.filter(c =>
        activeTags.find(t => c.tags.find(tag => t.id === tag.id))
      );
}

const Portfolio = props => {
  const allCaseStudies = props.data.caseStudies.edges.map(t => t.node);

  const allTags = extractUnique(
    allCaseStudies.map(c => c.tags).reduce((acc, val) => acc.concat(val), [])
  );

  const allGroups = [seeAllGroup, ...extractUnique(allTags.map(t => t.group))];

  const [activeGroup, setActiveGroup] = useState(allGroups[0]);
  const [activeTags, setActiveTags] = useState([]);

  const availableTags = allTags.filter(
    t => activeGroup.id === seeAllGroup.id || t.group.id === activeGroup.id
  );

  const caseStudies = filterCaseStudies(
    allCaseStudies,
    activeTags,
    allTags,
    activeGroup
  ).sort((a, b) => {
    return a.displayOrder - b.displayOrder;
  });

  function toggleTag(tag) {
    const tags = activeTags.find(t => t.id === tag.id)
      ? activeTags.filter(t => t.id !== tag.id)
      : [...activeTags, tag];

    setActiveTags(tags);
  }

  function handleGroupChange(value) {
    setActiveGroup(value);
    setActiveTags([]);
  }

  const allActiveClass = activeGroup.id === "0" ? style.allTagsActive : "";

  return (
    <div className={style.container}>
      <div className={style.content}>
        <div>
          <div className={style.groupSelector}>
            Show me{" "}
            <GroupSelector
              selected={activeGroup}
              options={allGroups}
              onChange={handleGroupChange}
            />
          </div>
          <div className={style.tagContainer + " " + allActiveClass}>
            <div
              className={style.tags + " tag-container columns  is-multiline"}
            >
              {availableTags.map((t, i) => (
                <div key={t.id} className={style.tag + " column is-one-third "}>
                  <span
                    className={
                      isTagActive(t.id, activeTags) ? style.isSelected : ""
                    }
                    onClick={() => toggleTag(t)}
                    onKeyPress={() => {}}
                    role="button"
                    tabIndex={i}
                  >
                    {t.name}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="cases columns  is-multiline cases">
          {caseStudies &&
            caseStudies.map(c => (
              <div key={c.slug} className="column is-one-quarter">
                <CaseStudy
                  url={`/case-studies/${c.slug}`}
                  case
                  clientName={c.name}
                  coverImage={c.thumbnailImage}
                  shortDescription={c.shortDescription.shortDescription}
                />
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default () => (
  <StaticQuery
    query={graphql`
      query PortfolioQuery {
        caseStudies: allContentfulCaseStudy(
          sort: { fields: displayOrder, order: ASC }
          filter: { isHidden: { ne: true } }
        ) {
          edges {
            node {
              id
              slug
              name
              displayOrder
              tags {
                id
                name
                group {
                  id
                  name
                }
              }
              shortDescription {
                shortDescription
              }
              thumbnailImage {
                fluid(maxWidth: 290, maxHeight: 370) {
                  ...GatsbyContentfulFluid
                }
              }
            }
          }
        }
      }
    `}
    render={(data, count) => <Portfolio data={data} count={count} />}
  />
);
